import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import { Button, Modal } from 'ui'
import { AccountStatementContext } from '../context/AccountStatementContext'

export function AccountToSendForm({
   isEmailModalOpen,
   setIsEmailModalOpen,
}: {
   isEmailModalOpen: boolean
   setIsEmailModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}) {
   const [inputEmails, setInputEmails] = React.useState<string | null>(null)
   const intl = useIntl()
   const { member, handleSendTryOnEmail, isLoading } = useContext(AccountStatementContext)
   const funcSendTryOnEmail = () => {
      if (inputEmails && member) {
         handleSendTryOnEmail(inputEmails, member.id, () => {
            setInputEmails(null)
            setIsEmailModalOpen(false)
         })
      }
   }
   return (
      <Modal visible={isEmailModalOpen && !!member}
         onClose={() => setIsEmailModalOpen(false)} size="md" >
         <Modal.Header>
            <h2 className="px-4 text-lg text-gray-600 font-bold"> {intl.formatMessage({ id: `settings.send.tryon` })}</h2>
         </Modal.Header>
         <Modal.Body className='p-8 font-semibold'>
            <p className='text-gray-600 mb-2'>
               {intl.formatMessage({ id: 'settings.form.tryon.for.externalId' }, {
                  externalId: <span className='font-normal'>{member?.externalId ?? intl.formatMessage({ id: 'settings.send.tryon.for.tittle.default' })}</span>
               })}:
            </p>
            <p className='text-gray-600 mb-2 font-semibold'>
               {intl.formatMessage({ id: 'settings.send.tryon.for.tittle' }, {
                  name: <span className='font-normal'>{member?.fullName ?? intl.formatMessage({ id: 'settings.send.tryon.for.tittle.default' })}</span>
               })}
            </p>
            <label htmlFor="name">
               <div className='text-gray-600 mb-2 font-bold'>
                  {intl.formatMessage({ id: 'settings.send.tryon.for' })}
               </div>
               <input type="text" id="name"
                  onChange={(e) => setInputEmails(e.target.value.trim())}
                  name="name" className='border border-gray-300 rounded-md p-2 w-full' placeholder={intl.formatMessage({ id: 'settings.send.tryon.for.placeholder' })} />
               <small className='text-gray-600'>{intl.formatMessage({ id: 'settings.send.tryon.for.textHelp' })}</small>
            </label>
         </Modal.Body>
         <Modal.Footer >
            <div className='px-4 flex gap-x-2 justify-end text-gray-600'>
               <Button bsStyle="default" onClick={() => setIsEmailModalOpen(false)} disabled={isLoading}>
                  {intl.formatMessage({ id: 'settings.button.cancel' })}
               </Button>
               <Button bsStyle="primary" buttonStyle={{ padding: '0 25px', background: '#3290fa', color: 'white' }} onClick={funcSendTryOnEmail} disabled={!inputEmails || isLoading} isLoading={isLoading}>
                  {intl.formatMessage({ id: 'settings.button.send' })}
               </Button>
            </div>
         </Modal.Footer>
      </Modal>
   )
}

